<template>
  <div class="km-page">
    <header class="km-top">
      <button class="km-back" @click="back()" aria-label="Back">
        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>
      </button>
      <div class="km-top__title"><span class="km-top__dot"></span><h1>{{ $t('setting.fill_bank') }}</h1></div>
      <div style="width:38px"></div>
    </header>

    <main class="km-main">
      <section class="km-section">
        <div class="km-intro">
          <div class="km-intro__ico">💳</div>
          <div class="km-intro__body">
            <h3>{{ $t('setting.fill_bank') }}</h3>
            <p>{{ $t('setting.fill_bank_tip') }}</p>
          </div>
        </div>

        <div class="km-card">
          <label class="km-field">
            <span class="km-field__lbl">{{ $t('setting.username') }}</span>
            <input v-model="username" :placeholder="$t('setting.username_place')"/>
          </label>
          <label class="km-field">
            <span class="km-field__lbl">{{ $t('setting.band_name') }}</span>
            <input v-model="bank" :placeholder="$t('setting.band_name_tip')"/>
          </label>
          <label class="km-field">
            <span class="km-field__lbl">{{ $t('setting.branch_name') }}</span>
            <input v-model="bankfenhang" :placeholder="$t('setting.branch_name_tip')"/>
          </label>
          <label class="km-field">
            <span class="km-field__lbl">{{ $t('setting.branch_code') }}</span>
            <input v-model="fhnumber" :placeholder="$t('setting.branch_code_tip')"/>
          </label>
          <label class="km-field">
            <span class="km-field__lbl">{{ $t('setting.band_account') }}</span>
            <input v-model="bankid" :placeholder="$t('setting.band_account_tip')"/>
          </label>
        </div>

        <p class="kbc-warn">⚠️ {{ $t('setting.bank_warn') }}</p>

        <div style="padding: 12px 4px 0;">
          <button class="km-btn" @click="bindCard()">{{ $t('setting.bank_ok') }}</button>
        </div>
      </section>
    </main>

    <van-popup v-model="showBank" round position="bottom" :style="{ height: '35%' }">
      <van-picker show-toolbar :columns="banks" @confirm="onConfirm" @cancel="onCancel"/>
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      banks: [], showBank: false, userInfo: {},
      bankid: "", username: "", mobile: "", bank: "", bank_code: "",
      bankfenhang: '', fhnumber: ""
    };
  },
  methods: {
    back() { return window.history.back(); },
    bindCard() {
      if (this.userInfo.bankid) { this.$toast(this.$t("setting.band_account_tip")); return true; }
      if (!this.bank) { this.$toast.fail(this.$t("setting.band_name_tip")); return false; }
      if (this.userInfo.bankid) { this.$toast(this.$t("setting.band_account_tip")); return true; }
      if (!this.username) { this.$toast(this.$t("setting.username_place")); return false; }
      if (!this.bankfenhang) { this.$toast(this.$t("setting.branch_name_tip")); return false; }
      if (!this.fhnumber) { this.$toast(this.$t("setting.branch_code_tip")); return false; }

      this.$http({
        method: 'post',
        data: { bankid: this.bankid, bank: this.bank, username: this.username, bankfenhang: this.bankfenhang, fhnumber: this.fhnumber },
        url: 'user_set_bank'
      }).then(res => {
        if (res.code === 200) { this.$router.push({ path: '/Mine' }); this.$toast(res.msg); }
        else if (res.code === 401) { this.$toast(res.msg); }
      });
    },
    showSelectBanks() { this.showBank = true; },
    getUserInfo() {
      this.$http({ method: 'get', url: 'user_info' }).then(res => {
        if (res.code === 200) { this.userInfo = res.data; this.name = res.data.name; }
        else if (res.code === 401) { this.$toast(res.msg); }
      });
    },
    getBankList() {
      this.$http({ method: 'get', url: 'sys_get_banks' }).then(res => {
        if (res.code === 200) this.banks = res.data;
        else if (res.code === 401) this.$toast(res.msg);
      });
    },
    onConfirm(value) { this.bank = value.text; this.bank_code = value.value; this.showBank = false; },
    onCancel() { this.showBank = false; },
    getUserBankInfo() {
      this.$http({ method: 'get', url: 'user_get_bank' }).then(res => {
        if (res.code === 200) this.is_bind = !!(res.data && res.data.is_bank);
        else if (res.code === 401) this.$toast(res.msg);
      });
    }
  },
  created() {
    if (!localStorage.getItem('token')) this.$router.push({ path: '/Login' });
    else { this.getUserInfo(); this.getBankList(); this.getUserBankInfo(); }
  }
};
</script>

<style lang="less" scoped>
@import "./_km-page.less";
.km-intro {
  display: flex; gap: 12px; align-items: flex-start;
  padding: 14px 16px; border-radius: 16px;
  background: linear-gradient(135deg, rgba(255,77,141,.08), rgba(160,32,240,.08));
  border: 1px solid rgba(255,77,141,.18);
  margin-bottom: 14px;
}
.km-intro__ico {
  width: 36px; height: 36px; border-radius: 10px;
  background: linear-gradient(135deg, #ff4d8d, #a020f0);
  display: flex; align-items: center; justify-content: center;
  font-size: 18px; flex-shrink: 0;
  box-shadow: 0 4px 10px rgba(255,77,141,.3);
}
.km-intro__body h3 { margin: 0 0 2px; font-size: 14px; font-weight: 800; color: #2a1a3f; }
.km-intro__body p { margin: 0; font-size: 12px; color: #5a4a78; line-height: 1.5; }

.kbc-warn {
  margin: 12px 4px 0; font-size: 12px; color: #ef4444;
  font-weight: 500; line-height: 1.5;
}

::v-deep .van-picker__toolbar { height: 44px; }
::v-deep .van-picker-column { font-size: 16px; }
</style>
